export default {
    resalesLanding: {
        sentOn: "Sent on",
        toggleContact: "Toggle agency contact",
        propertyOffers: "Property offers",
        openGallery: "Open photo gallery",
        prevPhoto: "Previous photo",
        nextPhoto: "Next photo",
        close: "Close",
        photo: "Photo",
        description: "Description",
        more: "More",
        less: "Less",
        intFloorSpace: "Int. Floor Space",
        build: "Build",
        terrace: "Terrace",
        garden: "Garden",
        buildYear: "Build Year",
        fees: "Fees",
        communityFees: "Community Fees",
        basuraTax: "Basura Tax",
        ibiFees: "IBI Fees",
        securityDeposit: "Security Deposit",
        perMonth: "/month",
        perWeek: "/week",
        disclaimer: "Disclaimer",
        energyCertificate: "Energy certificate",
        pending: "Pending",
        rating: "Rating",
        presentedBy: "Presented by",
        propertyDetails: "Property Details",
        reference: "Reference",
        referenceShort: "Ref",
        unitUnavailable: "No longer available",
        availableUnits: "Available Units and Pricing",
        availableUnitsShort: "Available Units",
        unit: "Unit",
        type: "Type",
        floors: "Floors",
        bedrooms: "Beds",
        bathrooms: "Baths",
        surfaceArea: "Internal",
        price: "Price",
        status: "Status",
        unitAvailable: "Available",
        unitReserved: "Reserved",
        unitSold: "Sold",
        seeMore: "See more",
        seeLess: "See less",
        floor: "Floor",
        storeys: "Storeys",
        keyReady: "Key Ready",
        touristLicence: "Tourist License",
        firstOccupationLicence: "First Occupancy License",
        notKnown: "Not Known",
        notProvided: "Not Provided",
        yes: "Yes",
        no: "No",
        mortgageAvailable: "Mortgage Available",
        guaranteedRental: "Guaranteed Rental",
        sellBeforeCompletion: "Contract Assignment Before Completion",
        sellBeforeCompletionYes: "Permitted",
        sellBeforeCompletionNo: "Not Permitted",
        sellBeforeCompletionNotProvided: "Not Provided",
        reservation: "Reservation",
        contract: "Contract",
        construction: "Construction",
        completion: "Completion",
        co2: "CO2",
        energyConsumption: "Energy Consumption",
        co2PerYear: "kg CO2/year",
        kwhPerYear: "kWh/year",
        features: "Features",
        viewDetails: "View Details",
        hideDetails: "Hide property details",
        backToResults: "Results",
        viewProperty: "View property",
        prevProperty: "Previous",
        nextProperty: "Next",
        viewAllFeatures: "View all features",
        allFeatures: "All features",
        infoOnRequest: "Information on request",
        tbc: "TBC",
        // Appended to bare feature qualifiers so they read clearly (see i18n
        // featureLabel). Order is value-then-category in English ("Heated Pool").
        featureCategoryLabels: { pool: "Pool", views: "Views", parking: "Parking", kitchen: "Kitchen", condition: "Condition", garden: "Garden" },
        featureQualifierFormat: "{value} {category}",
        location: "Location",
        agencyInformation: "Agency Information",
        buyingCosts: "Buying Costs",
        propertyPrice: "Property Price:",
        priceNote: "**The price does not include taxes or purchase costs.",
        estimatedPurchaseCosts: "Estimated Purchase Costs:",
        hide: "Hide",
        showBreakdown: "Show Purchase Cost Breakdown",
        purchaseCostBreakdown: "Purchase Cost Breakdown",
        concept: "Concept",
        application: "Application",
        rowTransferTax: "ITP (transfer tax, resale property)",
        rowVat: "VAT (new build)",
        rowVatLand: "VAT",
        vatApplication: "10% (4% for protected housing)",
        rowStampDuty: "Stamp Duty (AJD)",
        rowNotary: "Notary",
        rowLandRegistry: "Land Registry",
        officialTariff: "Official tariff",
        costRangeNotePrefix: "*Total buyer costs typically range between",
        and: "and",
        ofPurchasePrice: "of the purchase price.",
        costApproxNote: "*Estimated purchase costs are provided for guidance only. Actual costs may vary depending on the property and the buyer's circumstances. We recommend obtaining professional advice for an exact calculation.",
        additionalInformation: "Additional Information",
        addInfoDocument: "*Abbreviated Information Document available in accordance with Andalusian Decree 218/2005",
        addInfoNoFees: "*The buyer does not pay estate agency fees",
        formHeading: "Would you like to learn more about prices and the property?",
        firstName: "First Name",
        enterNumber: "Enter Number",
        email: "Email",
        searchCountry: "Search country or code",
        noMatches: "No matches",
        consent: "By clicking the button, you consent to the processing of your personal data in accordance with the Privacy Policy, including the collection, storage, and use of the provided information to contact you and provide the necessary information.",
        send: "Send",
        contactUs: "Contact us",
        yourMessage: "Your Message",
        agreeData: "I agree to provide my data for the purpose of receiving a response to my information request.",
        agreeContact: "I request to be informed and agree to be contacted by the company responsible for the promotion or relevant marketer, through my contact details, which I voluntarily provide for this purpose.",
        reject: "Reject",
        like: "Like",
        liked: "Liked",
        rejected: "Rejected",
        offerRejected: "Offer rejected",
        contact: "Contact",
        call: "Call",
        calling: "Calling",
        noPhone: "No phone available",
        enquirySent: "Enquiry sent — we'll contact",
        yourDetails: "your details",
        respondedTo: "responded to",
        noProperties: "No properties to display.",
        soldOutBody: "The properties in this offer have sold or are no longer on the market. Please contact the agency for an updated selection.",
        expiredTitle: "This offer link has expired",
        expiredBody: "Please contact the agency for an up-to-date link to view these properties.",
        unavailableTitle: "Offer unavailable",
        unavailableBody: "We couldn't load this offer. The link may be invalid or the service may be temporarily unavailable — please try again later or contact the agency.",
    },
    title: "{agencyName}'s properties",
    in: "in",
    propertiesFound: "properties found",
    toDay: "Today",
    days: "days",
    week: "Week",
    year: "Year",
    month: "Month",
    prev: "Prev",
    next: "Next",
    backToList: "Back to List",
    sorry: "Sorry , we",
    cantFind: "can't find",
    lookingFor: "the page you're looking for...",
    thankYou: "THANK YOU FOR VISITING OUR WEBSITE",
    pleaseContact: "Please contact the Agent for a new URL.",
    ForSale: "SALE",
    ShortTermRental: "Short Rent",
    LongTermRental: "Long Rent",
    showMore: "Show More",
    showLess: "Show Less",
    price: "Price",
    pricePer: "Price per",
    built: "Build",
    floorSpace: "Int. Floor Space",
    terrace: "Terrace",
    garden: "Garden",
    plot: "Plot",
    propTitle: '{subType} {searchType} in {location}',
    propTitleShort: '{subType} in {location}',
    notAvailable: "Not Available",
    notFound: 'Page not found',
    emptyProperties: "No properties were found, please contact your Agent for more information.",
    linkExpired: "Oops, this link has expired. Contact your estate agent to receive an updated property link.",
    newDevelopment: "New Development",
    agencyRaiiNo: "Agency's registration number",
    home: {
        verifyYourURLHere: "Verify your URL here. To do this, login to WhatsApp on your web browser, then copy the URL from WhatsApp to here.",
        pasteUrlHere: "Paste URL here",
        verifyUrl: "Verify URL",
        whatIsPropertyViewer: "What is Property-Viewer.com?",
        thisIsWebsiteIsUsed: "This website is used by Estate Agents to send properties to their clients. It is a product of {resalesonlinecom} If in doubt, please speak to the Agent who sent your property list to you.",
        howDoesItWork: "How does it work?",
        inThePast: "In the past, Agents would send PDF documents to their clients. However, these are not easy to view on many devices. Therefore we created {propertyviewercom} so that the client can more easily view properties sent to them.",
        createAShortList: "The Agent will create a short list of properties. When they share these properties with you, you will receive a link. Clicking on this link will show you the properties."
    },

    searchType: {
        ForSale: "for sale",
        ShortTermRental: "for short term rent",
        LongTermRental: "for long term rent",
    },

    rsStatus: {
        Available: "Available",
        Listing: "Listing",
        UnderOffer: "Under Offer",
        SaleAgreed: "Sale Agreed",
        OffMarket: "Off Market",
        Sold: "Sold",
        Rented: "Rented"
    },

    list: {
        propertyTitle: "Click here to view information for this property"
    },

    details: {
        average: "Average",
        averagePricesFor: "Average prices for ",
        showFullER: "Show Full",
        thisProperty: "This property",
        infoNotAvailable: "This information is not available.",
        feesEnergyRating: "Fees, Energy Rating",
        fees: "Fees",
        ibiFees: "IBI Fees",
        basuraTax: "Basura Tax",
        communityFees: "Community Fees",
        associatedCosts: "Associated Costs",
        securityDeposit: "Security Deposit",
        energyRating: "Energy Rating",
        energyCertificate: "Energy certificate",
        energyCertificatePending: "The energy certificate is pending",
        energyConsumption: "Energy Consumption",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per year",
        kwhPerYear: "kWh/m² per year",
        other: "Other info",
        buildYear: "Build year",
        forSale: "For sale",
        sold: "Sold",
        longTerm: "Long term",
        shortTermHigh: "Short term high",
        shortTermLow: "Short term low",
        allFeatures: "All features",
        aproxLocation: "Aprox. Location",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Tourist Registration Number",
        listingAgent: "Listing agent",
        agencyInformation: "Agency Information",
    },
};
